import $ from "jquery";
import axios from "@/vendors/axios";
import "magnific-popup/dist/jquery.magnific-popup";
const html = document.querySelector("html");
const locale = 'en';
const Album = {
    init: () => {
        const $albums = document.querySelectorAll(".album");
        if ($albums.length === 0)
            return;
        Album.loop($albums);
    },
    loop: (elements) => {
        elements.forEach((element) => {
            let filterControl = element.querySelector(".filter-control");
            let filterYear = element.querySelector("[name='filter-year']");
            let btnBack = element.querySelector(".btn-back");
            let albumHeader = element.querySelector(".album-header");
            let albumListing = element.querySelector(".album-listing");
            let photoListing = element.querySelector(".photo-listing");
            // @ts-ignore
            $(filterYear).on("change", (event) => {
                let $filterYear = event.target;
                const { value } = $filterYear;
                const row = albumListing.querySelector(".row");
                while (row.lastChild) {
                    row.removeChild(row.lastChild);
                }
                Album.fetchAlbums(element, value);
            });
            btnBack.addEventListener("click", () => {
                filterControl.classList.remove("d-none");
                albumListing.classList.remove("d-none");
                photoListing.classList.add("d-none");
                albumHeader.classList.add("d-none");
            });
            Album.bindAlbumCardEvent(element);
        });
    },
    fetchAlbums: async (element, year) => {
        const albumListing = element.querySelector(".album-listing");
        const row = albumListing.querySelector(".row");
        const { data } = await axios(`/api/trades/albums?year=${year}`);
        row.innerHTML = `${Album.renderAlbums(data)}`;
        Album.bindAlbumCardEvent(element);
        $(row).hide().fadeIn();
    },
    fetchPhotos: async (element, id, title) => {
        const photoListing = element.querySelector(".photo-listing");
        const albumtitle = element.querySelector(".album-header h4");
        const row = photoListing.querySelector(".row");
        const { data } = await axios(`/api/trades/albums/${id}`);
        const { album_items } = data.extras[locale];
        const albumItems = JSON.parse(album_items);
        row.innerHTML = `${Album.renderPhotos(albumItems, data.updated_at)}`;
        albumtitle.innerText = title;
        $(row).hide().fadeIn();
        $(".photo-listing").magnificPopup({
            delegate: "a",
            type: "image",
            gallery: {
                enabled: true,
            },
            removalDelay: 300,
            mainClass: "mfp-fade mfp-album",
            image: {
                markup: '<div class="mfp-figure">' +
                    '<div class="mfp-close"></div>' +
                    '<div class="mfp-img"></div>' +
                    '<div class="mfp-bottom-bar">' +
                    '<div class="mfp-bottom-left">' +
                    '<div class="mfp-title"></div>' +
                    '<div class="mfp-counter"></div>' +
                    "</div>" +
                    '<div class="mfp-bottom-right">' +
                    "<span>Share to: </span>" +
                    '<div class="a2a_kit a2a_kit_size_32 a2a_default_style">' +
                    '<li><a class="a2a_button_facebook"><i class="icon-facebook"></i></a></li>' +
                    '<li><a class="a2a_button_twitter"><i class="icon-twitter"></i></a></li>' +
                    '<li><a class="a2a_button_linkedin"><i class="icon-linkedin"></i></a></li>' +
                    '</div>' +
                    "</div>" +
                    "</div>" +
                    "</div>", // Popup HTML markup. `.mfp-img` div will be replaced with img tag, `.mfp-close` by close button
            },
            closeMarkup: '<button title="%title%" type="button" class="mfp-close"><i class="icon-x"></i></button>',
            callbacks: {
                open: () => {
                    window.a2a.init_all();
                },
            },
        });
    },
    renderAlbums: (data) => {
        return `${data
            .map((item) => `
      <div class="col-6 col-md-4 col-xl-3">
        <button type="button" data-album-id="${item.id}" data-album-title="${item.name[locale]}" class="card">
          <div class="card-thumbnail">
            <img src="/${item.featured_image}?ver=${new Date(item.updated_at).getTime()}" 
              alt="${item.name[locale]}" />
          </div>
          <div class="card-content">
            <span>
              ${item.name[locale]}
              <i class="icon-chevron-right"></i>
            </span>
          </div>
        </button>
      </div>`)
            .join("")}`;
    },
    renderPhotos: (data, updatedAt) => {
        return `${data
            .map((item, index) => `<div class="col-6 col-md-4 col-xl-3">
            <a href="/${item.image}?ver=${new Date(updatedAt).getTime()}" class="card image-link" title="${item.caption}">
              <div class="card-thumbnail">
                <img src="/${item.image}?ver=${new Date(updatedAt).getTime()}" 
                  alt="${item.caption}" />
              </div>
              ${item.caption
            ? `<div class="card-content">
                  <span>${item.caption}<i class="icon-chevron-right"></i></span>
                </div>`
            : ""}
            </a>
          </div>`)
            .join("")}`;
    },
    // renderModal: (id: string, href: string) => {
    //   const previousModal = document.getElementById(id);
    //   if (previousModal) {
    //     document.getElementById(id).remove();
    //   }
    //   const div = document.createElement("div");
    //   div.setAttribute("id", id);
    //   div.setAttribute("tabindex", "-1");
    //   div.classList.add("modal");
    //   div.classList.add("fade");
    //   div.classList.add("modal-album");
    //   div.innerHTML = `
    //     <div class="modal-dialog modal-dialog-centered modal-xl">
    //       <div class="modal-content">
    //         <div class="modal-body">
    //           <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
    //             <i class="icon-x"></i>
    //           </button>
    //           <img src='${href}' />
    //         </div>
    //         <div class="modal-footer">
    //           <span>Share to: </span>
    //           <ul class="addthis_toolbox addthis_default_style">
    //             <li><a class="addthis_button_facebook"><i class="icon-facebook"></i></a></li>
    //             <li><a class="addthis_button_twitter"><i class="icon-twitter"></i></a></li>
    //             <li><a class="addthis_button_linkedin"><i class="icon-linkedin"></i></a></li>
    //           </ul>
    //         </div>
    //       </div>
    //     </div>
    //   `;
    //   document.body.append(div);
    //   const $modal = new Modal(document.getElementById(id));
    //   $modal.show();
    //   addthis.toolbox(".addthis_toolbox");
    // },
    bindAlbumCardEvent: (element) => {
        let cards = element.querySelectorAll(".card");
        let filterControl = element.querySelector(".filter-control");
        let btnBack = element.querySelector(".btn-back");
        let albumHeader = element.querySelector(".album-header");
        let albumListing = element.querySelector(".album-listing");
        let photoListing = element.querySelector(".photo-listing");
        cards.forEach((card) => {
            card.addEventListener("click", (event) => {
                const { albumId, albumTitle } = card.dataset;
                const row = photoListing.querySelector(".row");
                albumListing.classList.add("d-none");
                photoListing.classList.remove("d-none");
                filterControl.classList.add("d-none");
                albumHeader.classList.remove("d-none");
                while (row.lastChild) {
                    row.removeChild(row.lastChild);
                }
                Album.fetchPhotos(element, albumId, albumTitle);
                event.preventDefault();
            });
        });
    },
};
export default Album;
